module.exports = __webpack_public_path__ + "img/business13.3e8c2256.png";